import script from "./AddCustomerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCustomerModal.vue?vue&type=script&setup=true&lang=js"

import "./AddCustomerModal.vue?vue&type=style&index=0&id=0ff4a172&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_06ebbe948ebbc1bd3ebd6c3aad4ab6ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ff4a172"]])

export default __exports__